<template>
  <div id="work-order-details-view">
    <div class="vx-row" v-if="![1, 3].includes(orderDetails.status.id)">
      <div class="vx-col w-full">
        <vx-card no-shadow style="background: transparent">
          <template  slot="actions">
            <vs-button @click="onClickViewWorkOrderOnTimeline" class="mr-0 mb-2" color="danger" type="border">View on manufacturing plan</vs-button>
          </template>
        </vx-card>
      </div>
    </div>
    <div class="vx-row" id="work-order-date-section">
      <div class="vx-col w-full">
        <vx-card>
          <div class="vx-row md:mb-3 mt-8">
            <div class="vx-col md:w-1/5 w-full">
              <vs-row vs-type="flex w-full" class="w-full">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                  <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">WO Code</h5>
                    <span class="text-primary font-bold">{{orderDetails.work_order_code}}</span>
                  </span>
                </vs-col>
              </vs-row>
            </div>
            <div class="vx-col md:w-1/5 w-full" v-if="orderDetails.status.id !== 1">
              <vs-row vs-type="flex w-full" class="w-full">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                  <feather-icon icon="CalendarIcon" class="text-success cursor-pointer"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Work Order Date</h5>

                      <flat-pickr
                        :config="{dateFormat: 'd/m/Y'}"
                        class="hidden"
                        v-model="orderDetails.work_order_date"
                        placeholder="Choose Date"/>

                      <flat-pickr :disabled="![1, 2].includes(orderDetails.status.id) || !$canAll(['update-work-order-times'])"
                                  :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="orderDetails.work_order_date"
                              placeholder="Choose Date"/>
                  </span>
                </vs-col>
              </vs-row>
            </div>
            <div class="vx-col md:w-1/5 w-full" v-if="orderDetails.status.id !== 1">
              <vs-row vs-type="flex w-full" class="w-full">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                  <feather-icon icon="ClockIcon" class="text-success cursor-pointer"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Work Order Start Time</h5>

                      <flat-pickr :disabled="![1, 2].includes(orderDetails.status.id) || !$canAll(['update-work-order-times'])"
                                  :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i',   time_24hr: true, disable: ['10:00']}" class="w-full" v-model="orderDetails.start_time"
                                  placeholder="Choose Time"/>
                  </span>
                </vs-col>
              </vs-row>
            </div>
            <div class="vx-col md:w-1/5 w-full" v-if="orderDetails.status.id !== 1">
              <vs-row vs-type="flex w-full" class="w-full">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                  <feather-icon icon="ClockIcon" class="text-success cursor-pointer"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Work Order End Time</h5>
                      <span class="text-lg">{{orderDetails.end_time}}</span>
<!--                      <flat-pickr disabled :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i',   time_24hr: true}" class="w-full" v-model="orderDetails.end_time"-->
<!--                                  placeholder="Choose Date"/>-->
                  </span>
                </vs-col>
              </vs-row>
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-row vs-type="flex w-full" class="w-full">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                  <feather-icon icon="ZapIcon" class="text-success cursor-pointer"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Status</h5>

                    <vs-dropdown  vs-trigger-hover class="cursor-pointer">
                      <a class="flex items-center text-dark ml-1" href="#">
                        <vs-chip class="text-center text-xs" transparent :color="workOrderColorFactory()">
                          {{ orderDetails.status.name }}
                        </vs-chip>
                        <i class="material-icons"> expand_more </i>
                      </a>
                      <vs-dropdown-menu>
                        <vs-dropdown-item class="w-64"
                                          @click="onClickStatusChange(status.url)"
                                          v-for="status in work_order_statuses"
                                          v-if="orderDetails.status.id !== status.id && status.is_visible && status.before_statuses.includes(orderDetails.status.name)"
                                          v-bind:key="status.name">
                          {{status.name}}
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>

                  </span>
                </vs-col>
              </vs-row>
            </div>
          </div>
          <div class="vx-row md:mb-3 mt-8" v-if="orderDetails.actual_start_time !== '00:00'">
            <div class="vx-col md:w-1/5 w-full">

            </div>
            <div class="vx-col md:w-1/5 w-full">

            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-row vs-type="flex w-full" class="w-full" v-if="orderDetails.actual_start_time !== '00:00'">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                  <feather-icon icon="ClockIcon" class="text-success cursor-pointer"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                      <h5 class="mb-2">Actual Start Time</h5>
                      <span class="text-lg">{{orderDetails.actual_start_time}}</span>
                  </span>
                </vs-col>
              </vs-row>
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <vs-row vs-type="flex w-full" class="w-full" v-if="orderDetails.actual_end_time !== '00:00'">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                  <feather-icon icon="ClockIcon" class="text-success cursor-pointer"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                      <h5 class="mb-2">Actual End Time</h5>
                      <span class="text-lg">{{orderDetails.actual_end_time}}</span>
                  </span>
                </vs-col>
              </vs-row>
            </div>
            <div class="vx-col md:w-1/5 w-full">
            </div>
          </div>
          <div  class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-if="[1, 2].includes(orderDetails.status.id)" @click="onClickTimeSubmit()" class="ml-auto mt-2">Save & Change</vs-button>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <vx-card>
          <div class="vx-row md:mb-3 mt-8">
            <div class="vx-col md:w-1/4 w-full">
              <vs-row vs-type="flex w-full" class="w-full">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                  <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">ITS Product Code</h5>
                    <span class="text-primary font-bold">
                        <vx-tooltip class="ml-2" text="View Product" position="left">
<!--                          <a v-on:click.stop="onClickFinishedProduct(data[indextr].id)">{{orderDetails.formulation_code}}</a>-->
                          <HyperLink :id="orderDetails.formulation_id" type="formulation">{{orderDetails.formulation_code}}</HyperLink>
                        </vx-tooltip>
                    </span>

                  </span>
                </vs-col>
              </vs-row>
            </div>
            <div class="vx-col md:w-1/4 w-full" >
              <vs-row vs-type="flex w-full" class="w-full">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                  <feather-icon icon="BoxIcon" class="text-success cursor-pointer"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">ITS Product Name</h5>
                    <span class="text-primary font-bold">
                      <HyperLink :id="orderDetails.formulation_id" type="formulation">{{orderDetails.formulation_name}}</HyperLink>
                    </span>
                  </span>
                </vs-col>
              </vs-row>
            </div>
            <div class="vx-col md:w-1/4 w-full hidden" v-if="!!orderDetails.required_by">
              <vs-row vs-type="flex w-full" class="w-full">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                  <feather-icon icon="CalendarIcon" class="text-success cursor-pointer"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Required By</h5>
                      <span class="text-lg">{{orderDetails.required_by}}</span>
                  </span>
                </vs-col>
              </vs-row>
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vs-row vs-type="flex w-full" class="w-full">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                  <feather-icon icon="UserIcon" class="text-success cursor-pointer"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Confirmed By</h5>
                      <span class="text-lg">{{orderDetails.confirmed_by || 'N/A'}}</span>
                  </span>
                </vs-col>
              </vs-row>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row mt-4">
      <div class="vx-col w-1/2 h-full">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full">
              <label class="text-sm opacity-100 text-bold">Production Line</label>
              <vs-input class="w-full" readonly v-model="orderDetails.production_line_id.production_line_code"/>
            </div>
          </div>

          <div class="vx-row mt-8">
            <div class="vx-col lg:w-full w-full">
              <vs-table noDataText="">
                <template>
                  <vs-tr>
                    <vs-td class="">Line Code</vs-td>
                    <vs-td class="font-bold text-primary">{{orderDetails.production_line_id.production_line_code ||
                      'N/A'}}
                    </vs-td>
                  </vs-tr>

                  <vs-tr>
                    <vs-td class="">Line Name</vs-td>
                    <vs-td class="font-bold text-primary">{{orderDetails.production_line_id.production_line_name ||
                      'N/A'}}
                    </vs-td>
                  </vs-tr>

                  <vs-tr>
                    <vs-td class="">Type</vs-td>
                    <vs-td class="font-bold text-primary">{{orderDetails.production_line_id.type || 'N/A'}}</vs-td>
                  </vs-tr>

                  <vs-tr>
                    <vs-td class="">Max Capacity (L)</vs-td>
                    <vs-td class="font-bold text-primary">{{toFixed(orderDetails.production_line_id.max_capacity_ltr) ||
                      'N/A'}}
                    </vs-td>
                  </vs-tr>

                  <vs-tr>
                    <vs-td class="">Max Capacity (KG)</vs-td>
                    <vs-td class="font-bold text-primary">{{toFixed(orderDetails.production_line_id.max_capacity_kg) || 'N/A'}}
                    </vs-td>
                  </vs-tr>

                  <vs-tr>
                    <vs-td class="">Clean Time (Mins)</vs-td>
                    <vs-td class="font-bold text-primary">{{orderDetails.production_line_id.clean_time_between_uses ||
                      'N/A'}}
                    </vs-td>
                  </vs-tr>

                  <vs-tr>
                    <vs-td class="">Description</vs-td>
                    <vs-td class="font-bold text-primary">{{orderDetails.production_line_id.description || 'N/A'}}
                    </vs-td>
                  </vs-tr>

                </template>
              </vs-table>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-1/2 h-full">
        <vx-card>
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickSubmit)">
              <div class="vx-row" id="work-order-right-section">
              </div>
              <vs-alert v-if="is_exceed" active="true" class="mt-4" color="danger" >
                The total quantity of selected items exceeds the maximum capacity of the product line
              </vs-alert>
              <div class="vx-row mt-8" v-if="orderDetails.order_items.length > 0">
                <div class="vx-col lg:w-full w-full">
                  <vs-table :hoverFlat="true"  noDataText="">

                    <template slot="thead">
                      <vs-th>Product Order Code</vs-th>
                      <vs-th>Required By</vs-th>
                      <vs-th>Customer</vs-th>
                      <vs-th>Manufacturing Quantity (KG)</vs-th>
<!--                      <vs-th></vs-th>-->
                    </template>

                    <template>
                      <vs-tr :key="index" v-for="(tr, index) in orderDetails.order_items">
                        <vs-td>
                          <vx-tooltip text="View Product Order" position="left">
                          <span style="cursor: pointer" class="text-primary" @click="onClickLink(tr.order_id)">{{tr.order_code}}</span>
                          </vx-tooltip>
                        </vs-td>
                        <vs-td>
                          {{ tr.required_by || 'N/A' }}
                        </vs-td>
                        <vs-td>
                           <HyperLink :id="tr.customer_id" type="customer">{{ tr.customer_name }} </HyperLink>
                        </vs-td>
                        <vs-td>
                          {{toFixed(tr.quantity)}}
                        </vs-td>
                       
<!--                        <vs-td>-->
<!--                          <ValidationProvider name="quantity" rules="required" v-slot="{ errors }" vid="quantity">-->
<!--                            <vs-input-number v-on:input="onInputQty()" class="w-full bg-white" label="Selected Quantity:"-->
<!--                                             :max="tr.max" min="0" name="quantity"-->
<!--                                             v-model="tr.quantity"/>-->
<!--                            <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>-->
<!--                          </ValidationProvider>-->
<!--                        </vs-td>-->
                      </vs-tr>
                      <vs-tr class="font-semibold">
                        <vs-td>Total</vs-td>
                        <vs-td></vs-td>
                        <vs-td></vs-td>
                        <vs-td>{{totalSelectedQuantityKilo}}</vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
              <div class="flex flex-wrap items-center justify-end mt-8">
                <h6>Manufacture unallocated stock in this work order (Kg) : {{Number(orderDetails.unallocated_amount).toFixed(2)}}</h6>
              </div>
              <div class="flex flex-wrap items-center justify-end mt-8">
                <h5>Total quantity to manufacture (Kg) : {{ totalQuantityToManufacture }}</h5>
              </div>
              <div class="vx-row mb-3 mt-4">
                <div class="vx-col w-full">
                  <ValidationProvider name="note" rules="" v-slot="{ errors }" vid="note">
                    <small class="label">Note</small>
                    <vs-textarea rows="5" class="w-full" name="note" v-model="orderDetails.note"/>
                    <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
<!--              <div v-if="orderDetails.status.id === 1" class="flex flex-wrap items-center justify-end mt-8">-->
<!--                <vs-button :disabled="is_exceed" button="submit" class="ml-auto mt-2">Update</vs-button>-->
<!--              </div>-->
            </form>
          </ValidationObserver>
        </vx-card>
      </div>
    </div>

    <div class="vx-row mt-4">
      <div class="vx-col w-full h-full">
        <vx-card title="Raw Materials / Products Used in WO">
              <div class="vx-row mt-8">
                <div class="vx-col lg:w-full w-full">
                  <vs-table stripe :hoverFlat="true"  noDataText="">

                    <template slot="thead">
                      <vs-th class="text-xs" width="5%">MON</vs-th>
                      <vs-th class="text-xs">ITS PRODUCT CODE</vs-th>
                      <vs-th class="text-xs">ITS PRODUCT NAME</vs-th>
                      <vs-th class="text-xs">TYPE</vs-th>
                      <vs-th class="text-xs">DISSOLVABLE</vs-th>
                      <vs-th class="text-xs">PHYSICAL STATE</vs-th>
<!--                      <vs-th class="text-xs">QUANTITY (Kg)</vs-th>-->
<!--                      <vs-th class="text-xs">QUANTITY (Ltr)</vs-th>-->
                    </template>

                    <template>
                      <vs-tr :key="index" v-for="(tr, index) in orderDetails.formulation">
                        <vs-td class="text-xs">
                          {{ tr.manufacture_order }}
                        </vs-td>
                        <vs-td class="text-xs font-semibold">
                          <span v-if="tr.company_product_code">{{tr.category}}-{{tr.company_product_code}}</span>
                          <span v-if="tr.formulation_code">{{ tr.formulation_code }}</span>
                          <span v-if="tr.code">{{ tr.code }}</span>
                        </vs-td>

                        <vs-td class="text-xs">
                          {{ tr.company_product_name || tr.name }}
                        </vs-td>

                        <vs-td class="text-xs"> {{ tr.type || '' }} </vs-td>
                        <vs-td class="text-xs"> {{ tr.dissolvable || '' }} </vs-td>
                        <vs-td class="text-xs"> {{ tr.physical_state || '' }} </vs-td>
<!--                        <vs-td class="text-xs"> {{ tr.quantity_kg || '' }} </vs-td>-->
<!--                        <vs-td class="text-xs"> {{ tr.quantity_lt || '' }} </vs-td>-->

                        <template class="expand-user" slot="expand">
                          <div class="con-expand-users w-4/5">
                            <vs-table :data="tr.assigned_raw_material">



                              <template slot="thead">
                                <vs-th class="text-xs" width="10%">BATCH NUMBER</vs-th>
                                <vs-th class="text-xs" width="10%">QTY (KG)</vs-th>
                              </template>

                              <template slot-scope="{data}">
                                <vs-tr :key="index_item" v-for="(tr_rm_item, index_item) in data">

                                  <vs-td class="text-xs">
                                    {{ tr_rm_item.batch_no }}
                                  </vs-td>

                                  <vs-td class="text-xs">
                                    {{ tr_rm_item.quantity }}
                                  </vs-td>

                                </vs-tr>
                              </template>

                            </vs-table>
                          </div>
                        </template>

                      </vs-tr>
<!--                      <vs-tr>-->
<!--                        <vs-td></vs-td>-->
<!--                        <vs-td></vs-td>-->
<!--                        <vs-td></vs-td>-->
<!--                        <vs-td></vs-td>-->
<!--                        <vs-td></vs-td>-->
<!--                        <vs-td></vs-td>-->
<!--                        <vs-td class="font-semibold">Total</vs-td>-->
<!--                        <vs-td class="font-semibold">{{totalRmQuantityKilo}}</vs-td>-->
<!--                        <vs-td class="font-semibold">{{totalRmQuantityLiter}}</vs-td>-->
<!--                      </vs-tr>-->
                    </template>
                  </vs-table>

                  <h5 v-if="orderDetails.is_reblended" class="mb-2 mt-8" style="color: #626262">Re-Blend FG stock</h5>

                  <vs-table
                    v-if="orderDetails.is_reblended"
                    :data="orderDetails.reblended_stock"
                    class="table-dark-inverted table-auto vs-con-loading__container">

                    <template slot="thead">
                      <vs-th width="15%" class="text-xs">BATCH CODE</vs-th>
                      <vs-th width="10%" class="text-xs">TOTAL QUANTITY (KG)</vs-th>
                      <vs-th width="10%" class="text-xs">COMPLETED QUANTITY (KG)</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].name">
                          {{ data[indextr].name}}
                        </vs-td>
                        <vs-td :data="data[indextr].total_quantity">
                          {{ toFixed(data[indextr].total_quantity) }}
                        </vs-td>
                        <vs-td :data="data[indextr].completed_quantity">
                          {{ toFixed(data[indextr].completed_quantity) }}
                        </vs-td>
                      </vs-tr>
                      <vs-tr class="font-semibold">
                        <vs-td>Total</vs-td>
                        <vs-td></vs-td>
                        <vs-td>{{toFixed(totalReBlendQuantity)}}</vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
        </vx-card>
      </div>
    </div>

    <div>

      
      <div class="vx-row mt-4 flex-start">

        
        <div class="vx-col w-1/2 h-full column-stack">

          
          <div v-if="orderDetails.is_rm_waste_used">
            <vx-card>
              <div class="vx-row mt-8">
                <div class="vx-col lg:w-full w-full">
                  <h5 class="mb-4" style="color: #626262">Raw Material Waste Item Used</h5>

                  <vs-table stripe :hoverFlat="true" noDataText="">
                    <template slot="thead">
                      <vs-th class="text-xs" width="25%">MIXED WORK ORDER</vs-th>
                      <vs-th class="text-xs">MIXED WORK ORDER QUANTITY (KG)</vs-th>
                      <vs-th class="text-xs">MIXED RAW MATERIAL ITEMS</vs-th>
                    </template>

                    <template>
                      <vs-tr :key="index" v-for="(tr, index) in orderDetails.rm_waste_items">

                        <vs-td class="text-xs">
                          {{ tr.mixed_work_order_code }}
                        </vs-td>

                        <vs-td class="text-xs font-semibold">
                          {{ Number(tr.mixed_work_order_quantity).toFixed(4) }}
                        </vs-td>

                        <vs-td class="text-xs text-primary">
                          <span v-for="(rm, index_ws) in tr.mixed_rmw_items" :key="index_ws">
                            {{ rm.raw_material + ' ,' }}
                          </span>
                        </vs-td>

                        <template slot="expand" class="expand-user">
                          <div class="con-expand-users w-2/3">
                            <vs-table stripe :hoverFlat="true" noDataText="">
                              <template slot="thead">
                                <vs-th class="text-xs" width="50%">ITS PROD CODE</vs-th>
                                <vs-th class="text-xs">QUANTITY (KG)</vs-th>
                              </template>

                              <template>
                                <vs-tr :key="index_wt" v-for="(tr_wt, index_wt) in tr.mixed_rmw_items">
                                  <vs-td class="text-xs">
                                    {{ tr_wt.raw_material }}
                                  </vs-td>
                                  <vs-td class="text-xs">
                                    {{ Number(tr_wt.quantity).toFixed(4) }}
                                  </vs-td>
                                </vs-tr>
                              </template>
                            </vs-table>
                          </div>
                        </template>

                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </vx-card>
          </div>

          
          <vx-card class="mt-4" title="Sundry Items">
            <vs-table :hoverFlat="true" noDataText="">
              <template slot="thead">
                <vs-th width="65%">Batch Number</vs-th>
                <vs-th width="35%">Quantity</vs-th>
              </template>

              <template>
                <vs-tr :key="index" v-for="(tr, index) in orderDetails.sundry_items">
                  <vs-td><HyperLink :id="tr.id" type="sundry" :open="true">{{tr.batch_no}}</HyperLink></vs-td>
                  <vs-td>{{ tr.quantity }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>

          <vx-card class="mt-4" title="Additional Tasks">
            <vs-table
              :hoverFlat="true"
              :data="tasks"
              class="">

              <template slot="thead">
                <vs-th width="40%" class="text-xs">CODE & NAME</vs-th>
                <vs-th width="20%" class="text-xs">START DATE</vs-th>
                <vs-th width="20%" class="text-xs">STATUS</vs-th>
                <vs-th width="20%" class="text-xs">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].scheduled_task_schedule.code">
                    {{ data[indextr].scheduled_task_schedule.code }} <br>
                    {{ data[indextr].scheduled_task_schedule.name }}
                  </vs-td>
                  <vs-td :data="data[indextr].started_at">
                    {{ data[indextr].started_at ? __dateTimeFormatterToDate(data[indextr].started_at) : 'N/A' }}
                  </vs-td>
                  <vs-td :data="data[indextr].status">
                    {{ data[indextr].status }}
                  </vs-td>
                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="ml-2" text="View/Edit Details" position="left" v-can="'view-quality-control-tastings'">
                        <vs-button size="small" @click.stop="onClickViewTask(data[indextr].id)"
                          color="warning" type="filled" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>

        </div>

        
        <div class="vx-col w-1/2 h-full column-stack">

          
          <div v-if="!isDilCodedFormulation">
            <vx-card class="mt-4" title="QC Test">
              <template slot="actions">
                <vs-button
                  size="small"
                  @click="onClickCreateQcTest('create', null)"
                  class="mr-4 mb-4"
                  color="primary"
                  type="filled"
                >
                  Create
                </vs-button>
              </template>

              <vs-table
                :data="qc_tests"
                class="table-dark-inverted table-auto vs-con-loading__container"
              >
                <template slot="thead">
                  <vs-th width="15%" class="text-xs">DATE</vs-th>
                  <vs-th width="15%" class="text-xs">DONE BY</vs-th>
                  <vs-th width="10%" class="text-xs">NOTE</vs-th>
                  <vs-th width="10%" class="text-xs">STATUS</vs-th>
                  <vs-th width="10%" class="text-xs">ACTION</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr
                    class="text-sm"
                    style="cursor: pointer"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td>
                      {{ __dateTimeFormatter(data[indextr].created_at) }}
                    </vs-td>
                    <vs-td>{{ data[indextr].done_by }}</vs-td>
                    <vs-td>{{ data[indextr].notes }}</vs-td>
                    <vs-td>{{ data[indextr].status }}</vs-td>

                    <vs-td>
                      <div class="vx-row">
                        <vx-tooltip class="ml-2" text="Update QC Test" position="left">
                          <vs-button
                            @click.stop="onClickCreateQcTest('update', data[indextr])"
                            size="small"
                            color="warning"
                            type="filled"
                            icon-pack="feather"
                            icon="icon-edit"
                          />
                        </vx-tooltip>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </div>

          
          <!-- <div>
            <vx-card class="mt-4" title="Taste Panel">
              <TastePanelList :batchId="this.id" batchType="Work Order"/>
            </vx-card>
          </div> -->

        </div>

      </div>

      </div>

    <confirm-work-order-pop-up ref="confirmWorkOrderPopUp"/>
    <add-qc-test-work-order-pop-up ref="addQcTestWorkOrderPopUp" v-on:refreshData="refreshData()"/>
  </div>


</template>

<script>
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");
  const ScheduledTasksRepository = RepositoryFactory.get('scheduled_tasks');

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import {work_order_statuses} from '@/constants/statuses'
  import ConfirmWorkOrderPopUp from "@/components/popups/manufacturing/work-order/ConfirmWorkOrderPopUp";
  import AddQcTestWorkOrderPopUp from "@/components/popups/manufacturing/work-order/qc-tests/AddQcTestWorkOrderPopUp";
  import moment from 'moment'
  import TastePanelList from '@/components/TastePanel/TastePanelList.vue';

  export default {
    name: "WorkOrderView",
    data() {
      return {
        orderDetails: {
          id: '',
          production_line_id: {},
          work_order_code: '',
          formulation_code: '',
          formulation_name: '',
          work_order_date: '',
          start_time: '',
          end_time: '',
          required_by: '',
          order_items: [],
          unallocated_amount: '',
          formulation: [],
          note: '',
          confirmed_by: '',
          status: {},
          formulation_type: ''
        },
        work_order_statuses: work_order_statuses,
        id: '',
        order_formulations_items: [],
        production_line_id: '',
        note: '',
        is_exceed: false,
        qc_tests: [],
        tastingFormList:[],
        tasks: []
      }
    },
    components: {
      flatPickr,
      ConfirmWorkOrderPopUp,
      AddQcTestWorkOrderPopUp,
      TastePanelList
    },
    mixins: [SuccessMessage, ErrorMessages],
    async mounted() {
      this.id = this.$route.params.id;
      await this.getWorkOrderDetails()
    },
    methods: {
      async refreshData() {
        await this.getWorkOrderDetails()
      },
      async getWorkOrderDetails() {
        await this.$vs.loading({
          container: '#work-order-details-view',
          scale: 0.45
        });
        try {
          const {data} = (await ManufacturingRepository.getWorkOrder(this.id)).data;
          this.orderDetails = data;
          this.orderDetails.end_time = this.__utcToLocalTime(this.orderDetails.end_time)
          this.orderDetails.start_time = this.__utcToLocalTime(this.orderDetails.start_time)
          this.orderDetails.actual_end_time = this.__utcToLocalTime(this.orderDetails.actual_end_time)
          this.orderDetails.actual_start_time = this.__utcToLocalTime(this.orderDetails.actual_start_time)
          this.orderDetails.order_items = data.order_items.map((n) => {
            n.pending_manufacture_quantity = Number(n.pending_manufacture_quantity)
            n.quantity = Number(n.quantity)
            n.max = Number(n.quantity) + Number(n.pending_manufacture_quantity)
            return n
          })
          if(this.orderDetails.formulation_formulation.length > 0) {
            this.orderDetails.formulation_raw_material = this.orderDetails.formulation_raw_material.concat(this.orderDetails.formulation_formulation)
          }
          if(this.orderDetails.formulation_type === 'spray dry powder') {
            this.orderDetails.formulation_raw_material = this.orderDetails.formulation_raw_material.concat(this.orderDetails.formulation_spray_dry_carrier)
          }
          this.orderDetails.formulation = this.orderDetails.formulation_raw_material.sort((a, b) => {
            if (a.manufacture_order < b.manufacture_order) return -1
            return a.manufacture_order > b.manufacture_order ? 1 : 0
          })
          await this.getWorkOrderQcTest()
          // await this.getTasteFormList()
          await this.fetchTasks()
        } catch (e) {

        }
        this.$vs.loading.close('#work-order-details-view > .con-vs-loading')

      },
      async fetchTasks() {
        try {
          const response = await ScheduledTasksRepository.getListOfAllTaskInstances(`filter[reference_type]=Work Order&filter[reference_id]=${this.id}`);
          this.tasks = response.data.data;
        } catch (error) {}
      },
      onClickViewTask(task_id){
        let route = this.$router.resolve({path: `/pages/task-instance/${task_id}`});
        window.open(route.href, '_blank');
      },
      async getTasteFormList() {
        try {
          const response =
            await TriangleTestsRepository.getListOfQualityControlTestings(`filter[batch_id]=${this.id}&filter[batch_type]=${'Work Order'}`);
          this.tastingFormList = response.data.data;
        } catch (e) {}
      },
      async onClickViewTasteForm(id){
        let route = this.$router.resolve({path: `/pages/taste-panels?open=${id}`});
        window.open(route.href, '_blank');
      },
      async getWorkOrderQcTest() {
        const {data} = (await ManufacturingRepository.getWorkOrderQcTest(this.id)).data;
        this.qc_tests= data
      },
      async onClickLink(id) {
          this.$router.push({path: `/pages/product-orders/${id}`})
      },

      async onClickSubmit() {
        await this.$vs.loading({
          container: '#work-order-right-section',
          scale: 0.45
        });
        try {
          const formulation_order_item_ids =  this.orderDetails.order_items.map((n) => {
              if (Number(n.quantity) > 0) {
              return {id: n.id, quantity: n.quantity}
              }
          }).filter((n) => {
              return n !== undefined;
          })

          let payload = {
            production_line_id: this.orderDetails.production_line_id.id,
            formulation_order_item_ids,
            note: this.note
          };
          await ManufacturingRepository.updateWorkOrder(this.id, payload);
          this.showSuccessMessage('Work order updated successfully');
          this.$router.push({path: `/pages/manufacturing/work-orders`})
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#work-order-right-section > .con-vs-loading')

      },
      onInputQty() {
        const production_line_total_quantity = this.orderDetails.production_line_id.max_capacity_kg
        const total_selected_item_quantity = this.orderDetails.order_items.filter((m) => !!m.quantity).reduce(function(acc, val) { return acc + Number(val.quantity); }, 0)
        if(Number(total_selected_item_quantity) > Number(production_line_total_quantity)) {
          this.is_exceed = true
        } else {
          this.is_exceed = false
        }
      },
      async onClickTimeSubmit() {
        await this.$vs.loading({
          container: '#work-order-date-section',
          scale: 0.45
        });
        try {
          const payload = {
            work_order_date: this.orderDetails.work_order_date,
            start_time: moment(this.orderDetails.start_time, 'HH:mm').utc().format('HH:mm'),
            production_line_id: this.orderDetails.production_line_id.id
          }
          await ManufacturingRepository.updateWorkOrderDateTime(this.id, payload);
          this.showSuccessMessage('Work order updated successfully');
          await this.getWorkOrderDetails()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#work-order-date-section > .con-vs-loading')
      },
      workOrderColorFactory() {
        const color  = this.work_order_statuses.find((n) => n.id === this.orderDetails.status.id)
        return color ? color.color : 'dark'
      },
      async onClickStatusChange(url) {
        if (url === 'confirm') {
          this.$refs.confirmWorkOrderPopUp.openPopup(this.orderDetails.id, this.orderDetails.production_line_id.id)
        } else {
          await this.$vs.loading({
            container: '#work-order-date-section',
            scale: 0.45
          });
          try {
            await ManufacturingRepository.workOrderStatusChange(this.orderDetails.id, url, {})
            this.showSuccessMessage('Work order status changed successfully')
            await this.refreshData()
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close('#work-order-date-section > .con-vs-loading')
        }

      },
      toFixed(number) {
        return Number(number).toFixed(2)
      },
      onClickCreateQcTest(method, data = {}) {
        this.$refs.addQcTestWorkOrderPopUp.openPopup(this.id, this.orderDetails.formulation_type, method, data, this.orderDetails.formulation_id)
      },
      async onClickViewWorkOrderOnTimeline() {
        this.$router.push({path: `/pages/manufacturing/manufacturing-timeline?wo=${this.orderDetails.id}`})
      },
    },
    computed: {
      totalSelectedQuantityKilo() {
        const total = this.orderDetails.order_items.reduce(function (acc, val) {
          return acc + Number(val.quantity);
        }, 0);
        return total.toFixed(2)
      },
      totalQuantityToManufacture() {
        const total = Number(this.totalSelectedQuantityKilo) + Number(this.orderDetails.unallocated_amount)
        return Number(total).toFixed(2)
      },
      totalReBlendQuantity() {
        const total = this.orderDetails.reblended_stock.reduce(function (acc, val) {
          return acc + Number(val.completed_quantity);
        }, 0);
        return total.toFixed(2)
      },
      totalRmQuantityKilo() {
        const total = this.orderDetails.formulation.reduce(function (acc, val) {
          return acc + Number(val.quantity_kg);
        }, 0);
        return total.toFixed(2)
      },
      totalRmQuantityLiter() {
        const total = this.orderDetails.formulation.reduce(function (acc, val) {
          return acc + Number(val.quantity_lt);
        }, 0);
        return total.toFixed(2)
      },
      isDilCodedFormulation: function () {
        return this.orderDetails.formulation_code.includes('DIL-')
      },
    }
  }
</script>

<style scoped>

.flex-start {
  align-items: flex-start !important;
}

.column-stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

</style>
